//lib
import React from "react";
import { Controller } from "react-hook-form";

//src
import AdditionalFormFields from "../common-type";
import DateRangePickerField from "./date-range-picker";
import { dateRangePickerProps } from "./date-range-picker.type";

export const DateTimePickerFormField = (props) => {
  const { name, defaultValue, control, isRequired } = props;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <DateRangePickerField
          {...props}
          isRequired={isRequired}
          value={value}
          onChange={onChange}
          error={error}
        />
      )}
    />
  );
};
DateTimePickerFormField.propTypes = {
  ...dateRangePickerProps,
  ...AdditionalFormFields,
};

export default React.memo(DateTimePickerFormField);
